export default "__VITE_ASSET__CHZ9XEMS__"